import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const environment = {
  production: false,
  apiUrl: 'https://api.dev.yawipark.com'
};

export const externalModules = [
  StoreDevtoolsModule.instrument({
    maxAge: 25
  })
];

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
